var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "k\\xE9p_ikon",
    transform: "translate(-1717.505 -601.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10861",
    d: "M1744.005,632.2h-22a4.506,4.506,0,0,1-4.5-4.5v-22a4.5,4.5,0,0,1,4.5-4.5h22a4.5,4.5,0,0,1,4.5,4.5v22A4.5,4.5,0,0,1,1744.005,632.2Zm-22-30a3.5,3.5,0,0,0-3.5,3.5v22a3.5,3.5,0,0,0,3.5,3.5h22a3.5,3.5,0,0,0,3.5-3.5v-22a3.5,3.5,0,0,0-3.5-3.5Z",
    fill: "#929ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10862",
    d: "M1737.175,631.437l-.26.26h-14.91a4,4,0,0,1-4-4v-1.44l7-7,4.13,4.13Z",
    fill: "#929ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10863",
    d: "M1748.005,622.356V627.7a4.005,4.005,0,0,1-4,4h-21.92l-.63-.63,17.63-17.63Z",
    fill: "#929ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16821"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_347",
    cx: 3.326,
    cy: 3.326,
    r: 3.326,
    transform: "translate(1722.391 605.739)",
    fill: "#929ea7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.d93163cfd13d954da5468f4a9b8e212f.svg";
export { ForwardRef as ReactComponent };